module.exports = __webpack_public_path__ + "static/img/3.c6b012c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R507/3.jpg
// module id = QQK9
// module chunks = 1